export const REPORT_REASON_OPTIONS = [
  { label: "It's spam", value: "spam" },
  { label: "Nudity or sexual activity", value: "nudity" },
  { label: "Hate speech or symbols", value: "hate" },
  { label: "Violence or dangerous organizations", value: "violence" },
  { label: "Bullying or harassment", value: "harassment" },
  { label: "Irrelevant", value: "irrelevant" },
];
